import {NgModule} from '@angular/core';

import {MzNavbarItemContainerComponent} from './navbar-item-container';
import {MzNavbarItemComponent} from './navbar-item';
import {MzNavbarComponent} from './navbar.component';

@NgModule({
  declarations: [
    MzNavbarComponent,
    MzNavbarItemComponent,
    MzNavbarItemContainerComponent,
  ],
  exports: [
    MzNavbarComponent,
    MzNavbarItemComponent,
    MzNavbarItemContainerComponent,
  ],
})
export class MzNavbarModule {
}
